// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3fh4F","rootNoMargin":"styles_rootNoMargin__-hD2K"};